"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC998CompositionsSearch = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_intl_1 = require("react-intl");
const mui_form_search_1 = require("@dzambalaorg/mui-form-search");
const ui_kit_1 = require("@dzambalaorg/ui-kit");
const types_1 = require("../../../../../types");
const inputs_1 = require("../../../../../inputs");
const schemas_1 = require("./schemas");
const ERC998CompositionsSearch = (props) => {
    const { service, initialSearchValues } = props;
    const { formatMessage } = (0, react_intl_1.useIntl)();
    const columns = {
        [types_1.ServiceType.ADMIN]: [2],
        [types_1.ServiceType.OFFICE]: [3],
    };
    return ((0, jsx_runtime_1.jsx)(mui_form_search_1.SearchWithFilters, { initialValues: initialSearchValues, children: (0, jsx_runtime_1.jsxs)(ui_kit_1.FormGrid, { columns: columns[service], containerProps: { sx: theme => ({ marginTop: theme.spacing(theme.tokens.spacing.xl) }) }, children: [service === types_1.ServiceType.OFFICE && (0, jsx_runtime_1.jsx)(inputs_1.SearchMerchantInput, { disableClear: true }), (0, schemas_1.renderParentIdsInput)(formatMessage)[service], (0, schemas_1.renderChildIdsInput)(formatMessage)[service]] }) }));
};
exports.ERC998CompositionsSearch = ERC998CompositionsSearch;
//# sourceMappingURL=index.js.map